import { Trans } from 'react-i18next';

import { resolveDeclensionTranslationKey, Translate, useTranslate } from '@dreryk/react-common';
import { Link, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { sharedTranslationKeys } from '../../../translations';

const t = sharedTranslationKeys.attachmentsLinks;

type AvailableLinkViewProps = Readonly<{
   restAvailableAttachmentsCounts: number;
   onShowMoreAvailableAttachments: VoidFunction;
}>;

export const AvailableLinkView = (props: AvailableLinkViewProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <Translate>{t.or}</Translate>
         <span>
            <Link
               testId='showMoreAvailableAttachments'
               block={false}
               onClick={props.onShowMoreAvailableAttachments}
               label={
                  <Trans
                     i18nKey={t.restAttachments}
                     values={{
                        count: props.restAvailableAttachmentsCounts,
                        declensionForm: translate(
                           resolveDeclensionTranslationKey(
                              props.restAvailableAttachmentsCounts,
                              t.moreAvailableAttachmentsCount.nominative,
                              t.moreAvailableAttachmentsCount.accusative,
                              t.moreAvailableAttachmentsCount.genitive
                           )
                        ),
                     }}
                  />
               }
            />
         </span>
      </TextSeparator>
   );
};
